module.exports = __webpack_public_path__ + "static/media/facebook.ff6b525e.svg";